import { render, staticRenderFns } from "./pindaan-e.vue?vue&type=template&id=0785fa00&"
import script from "./pindaan-e.vue?vue&type=script&lang=js&"
export * from "./pindaan-e.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports